export default {
  initial: 1,
  eco: 2,
  variant: 3,
  ota: 20,
  renewal: 7
};
